module.exports = __webpack_public_path__ + "files/cdc199d94df8c6f619361a11c2572a6f.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Lora-regular.ttf
// module id = 619
// module chunks = 60